/* ══════════════════════════════════════════════════════════════
   UI Utilities — Toast, Confirm Dialog, and Async Lucide Icon Engine
   Decoupled from main.js for clean code splitting & 0-overhead initial load
   ══════════════════════════════════════════════════════════════ */

export const ICON_MAP = {
  // Nav
  'nav-icon-snowflake': { name: 'Snowflake', size: 20 },
  'nav-icon-phone': { name: 'Phone', size: 16 },
  'nav-icon-calendar': { name: 'CalendarCheck', size: 16 },
  'nav-icon-menu': { name: 'Menu', size: 22 },
  'nav-mobile-calendar': { name: 'CalendarPlus', size: 16 },
  'nav-mobile-phone': { name: 'Phone', size: 16 },

  // Hero
  'hero-icon-calendar': { name: 'CalendarPlus', size: 20 },
  'hero-icon-phone': { name: 'PhoneCall', size: 20 },
  'hero-icon-check': { name: 'CircleCheck', size: 16 },
  'hero-icon-check2': { name: 'CircleCheck', size: 16 },
  'hero-icon-check3': { name: 'CircleCheck', size: 16 },

  // Benefits
  'benefit-icon-1': { name: 'HeartPulse', size: 22 },
  'benefit-icon-2': { name: 'Zap', size: 22 },
  'benefit-icon-3': { name: 'ShieldCheck', size: 22 },
  'benefit-icon-4': { name: 'Gauge', size: 22 },

  // Booking Wizard AC Types
  'wizard-ac-icon-wall': { name: 'AirVent', size: 16 },
  'wizard-ac-icon-ceiling': { name: 'Grid2x2', size: 16 },
  'wizard-ac-icon-standing': { name: 'Server', size: 16 },
  'wizard-ac-icon-multi': { name: 'Layers', size: 16 },

  // Frequency table - Customer Types
  'freq-icon-home': { name: 'Home', size: 18 },
  'freq-icon-office': { name: 'Building2', size: 18 },
  'freq-icon-factory': { name: 'Factory', size: 18 },
  'freq-icon-restaurant': { name: 'UtensilsCrossed', size: 18 },

  // Promo card
  'promo-icon-tag': { name: 'Tag', size: 20 },
  'promo-icon-badge': { name: 'BadgeCheck', size: 20 },
  'promo-icon-clipboard': { name: 'ClipboardCheck', size: 20 },

  // Process steps
  'step-icon-1': { name: 'PhoneCall', size: 22 },
  'step-icon-2': { name: 'Power', size: 22 },
  'step-icon-3': { name: 'SprayCan', size: 22 },
  'step-icon-4': { name: 'Fan', size: 22 },
  'step-icon-5': { name: 'Gauge', size: 22 },
  'step-icon-6': { name: 'CheckCircle', size: 22 },

  // Deep clean & Disinfect
  'deep-clean-icon': { name: 'Sparkles', size: 20 },
  'disinfect-icon': { name: 'ShieldAlert', size: 20 },

  // Knowledge blog
  'blog-icon-book': { name: 'BookOpen', size: 20 },

  // About
  'about-icon-1': { name: 'Users', size: 24 },
  'about-icon-2': { name: 'Wrench', size: 24 },
  'about-icon-3': { name: 'Receipt', size: 24 },
  'about-icon-4': { name: 'FlaskConical', size: 24 },
  'about-icon-5': { name: 'Clock', size: 24 },
  'about-icon-6': { name: 'MapPin', size: 24 },

  // Contact
  'contact-icon-phone': { name: 'Phone', size: 20 },
  'contact-icon-zalo': { name: 'MessageCircle', size: 20 },
  'contact-icon-location': { name: 'MapPin', size: 20 },
  'footer-icon-location': { name: 'MapPin', size: 16 },
  'footer-icon-phone': { name: 'Phone', size: 16 },
  'footer-icon-email': { name: 'Mail', size: 16 },
  'footer-icon-clock': { name: 'Clock', size: 16 },

  // Admin Dashboard
  'admin-logo-icon': { name: 'Snowflake', size: 18 },
  'admin-icon-collapse-left': { name: 'ChevronLeft', size: 16 },
  'admin-icon-collapse-right': { name: 'ChevronRight', size: 16 },
  'admin-icon-dashboard': { name: 'LayoutDashboard', size: 16 },
  'admin-icon-bookings': { name: 'CalendarRange', size: 16 },
  'admin-icon-reminders': { name: 'Clock', size: 16 },
  'admin-icon-blog': { name: 'FileText', size: 16 },
  'admin-icon-logout': { name: 'LogOut', size: 16 },
  'admin-login-logo': { name: 'ShieldCheck', size: 24 },
  'stat-icon-total': { name: 'ClipboardList', size: 22 },
  'stat-icon-pending': { name: 'Clock', size: 22 },
  'stat-icon-completed': { name: 'CheckCircle', size: 22 },
  'stat-icon-revenue': { name: 'Coins', size: 22 },

  // Modals
  'auth-modal-logo': { name: 'User', size: 18 },
  'booking-modal-icon': { name: 'Sparkles', size: 20 },

  // Submit & Footer
  'submit-icon': { name: 'Send', size: 18 },
  'footer-icon-logo': { name: 'Snowflake', size: 18 },
  'floating-phone-icon': { name: 'Phone', size: 24 },

  // Periodic Reminders
  'rem-icon-tab-bell': { name: 'BellRing', size: 14 },
  'rem-icon-usp-calendar': { name: 'CalendarCheck', size: 24 },
  'rem-icon-usp-gift': { name: 'Gift', size: 24 },
  'rem-icon-usp-bell': { name: 'Bell', size: 24 },
  'rem-icon-gift-inline': { name: 'Gift', size: 14 },
  'rem-icon-snowflake-inline': { name: 'Snowflake', size: 16 },
  'rem-icon-large-bell': { name: 'BellRing', size: 20 },
};

export const ICONS = {};

// ══════════════════════════════════════════════════════════════
// TOAST NOTIFICATIONS & CONFIRM DIALOGS
// ══════════════════════════════════════════════════════════════
export function showToast(message, type = 'success') {
  // Toast notifications disabled per user request
  return;
}

export function showConfirmDialog({
  title = 'Xác nhận hành động',
  message = 'Bạn có chắc chắn muốn tiếp tục thực hiện hành động này không?',
  icon = '⚠️',
  confirmText = 'Xác nhận',
  cancelText = 'Hủy bỏ',
  type = 'danger'
} = {}) {
  return new Promise((resolve) => {
    let dialog = document.getElementById('global-confirm-dialog');
    if (!dialog) {
      dialog = document.createElement('div');
      dialog.id = 'global-confirm-dialog';
      dialog.className = 'fixed inset-0 z-[250] flex items-center justify-center p-4 bg-slate-950/70 backdrop-blur-md transition-opacity duration-300 animate-fade-in';
      document.body.appendChild(dialog);
    }

    const confirmBtnClass = type === 'danger'
      ? 'bg-rose-600 hover:bg-rose-700 text-white shadow-rose-500/20'
      : 'bg-primary-600 hover:bg-primary-700 text-white shadow-primary-500/20';

    dialog.innerHTML = `
      <div class="relative w-full max-w-sm bg-white rounded-3xl p-6 shadow-2xl border border-sky-100 animate-slide-up text-center space-y-4">
        <div class="w-14 h-14 mx-auto rounded-2xl ${type === 'danger' ? 'bg-rose-50 text-rose-500 border border-rose-100' : 'bg-sky-50 text-primary-600 border border-sky-100'} flex items-center justify-center text-2xl shadow-inner">
          ${icon}
        </div>
        <div>
          <h4 class="text-base sm:text-lg font-bold text-gray-900">${title}</h4>
          <p class="text-xs text-gray-500 mt-1.5 leading-relaxed">${message}</p>
        </div>
        <div class="grid grid-cols-2 gap-2.5 pt-2">
          <button id="dialog-btn-cancel" class="w-full py-2.5 px-4 rounded-xl border border-gray-200 hover:bg-gray-50 text-xs font-semibold text-gray-700 transition-colors cursor-pointer">
            ${cancelText}
          </button>
          <button id="dialog-btn-confirm" class="w-full py-2.5 px-4 rounded-xl font-bold text-xs shadow-md transition-all duration-200 cursor-pointer ${confirmBtnClass}">
            ${confirmText}
          </button>
        </div>
      </div>
    `;

    dialog.classList.remove('hidden');
    dialog.classList.add('flex');

    const cleanUp = (result) => {
      dialog.classList.add('hidden');
      dialog.classList.remove('flex');
      resolve(result);
    };

    document.getElementById('dialog-btn-cancel')?.addEventListener('click', () => cleanUp(false), { once: true });
    document.getElementById('dialog-btn-confirm')?.addEventListener('click', () => cleanUp(true), { once: true });
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) cleanUp(false);
    }, { once: true });
  });
}

// ══════════════════════════════════════════════════════════════
// RENDER ICONS ENGINE (Lazy loaded on demand)
// ══════════════════════════════════════════════════════════════
export async function renderIcons(rootElement = document) {
  try {
    const lucide = await import('lucide');
    for (const [key, config] of Object.entries(ICON_MAP)) {
      const elements = rootElement.querySelectorAll(`#${key}, [data-icon="${key}"]`);
      if (!elements.length) continue;

      const iconData = lucide[config.name];
      if (!iconData) continue;

      elements.forEach(el => {
        if (el.querySelector('svg')) return; // Already has inline SVG, skip!
        const svgEl = lucide.createElement(iconData);
        svgEl.setAttribute('width', config.size);
        svgEl.setAttribute('height', config.size);
        svgEl.setAttribute('stroke-width', '2');
        el.innerHTML = '';
        el.appendChild(svgEl);
      });
    }
  } catch (e) {
    console.warn('[renderIcons error]', e);
  }
}
